import React, { useContext, useEffect } from 'react'

import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import LazyLoad from 'vanilla-lazyload'

import { ModalContext } from '../../context/ModalContext'
import { usePageCleanup } from '../../hooks'
import useAfterHours from '../../hooks/useAfterHours'
import useDebug from '../../hooks/useDebug'
import GlobalStyle from '../../style/Global'
import GlobalFooter from '../footers/GlobalFooter'
import StickyMobileFooter from '../footers/StickyMobileFooter'
import GlobalHeader from '../headers/GlobalHeader'
import Footnotes from './Footnotes'
import SEO from './seo'

const Layout = ({ children }) => {
  const cleanState = usePageCleanup()
  const { activeModal, isModalActive } = useContext(ModalContext)
  useAfterHours()
  useDebug()

  // instantiate vanilla lazy loading
  // todo: remove this and covert remaining images to gatsby-images
  useEffect(() => {
    const lazyloadConfig = {
      elements_selector: '.lazy',
    }
    document.lazyLoadInstance = new LazyLoad(lazyloadConfig)
    document.lazyLoadInstance.update()
  }, [])

  // cleanup state values that need to be reset when the layout changes
  // i.e. pathlabel
  useEffect(() => () => cleanState, [cleanState])

  return (
    <>
      <Helmet>
        {/* https://www.filamentgroup.com/lab/load-css-simpler/ */}
        <link
          rel="stylesheet"
          href="https://use.typekit.net/sni0lyn.css"
          // this is causing a flash so we're reverting for now.
          // see link above to read why we tried this.
          // media="print"
          // onLoad="this.media='all'; this.onload=null;"
        />
      </Helmet>
      <SEO title="Ultimate Medical Academy" />
      <GlobalHeader />
      <div>{children}</div>
      <Footnotes />
      <GlobalFooter />
      <StickyMobileFooter />
      {isModalActive && activeModal()}
      <GlobalStyle />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
